import { render, staticRenderFns } from "./DeletePresetModal.vue?vue&type=template&id=35cc22f1&scoped=true"
import script from "./DeletePresetModal.vue?vue&type=script&lang=js"
export * from "./DeletePresetModal.vue?vue&type=script&lang=js"
import style0 from "./DeletePresetModal.vue?vue&type=style&index=0&id=35cc22f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc22f1",
  null
  
)

export default component.exports